var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 7a.5.5 0 01-.354-.854L2.792 3.5.146.854A.5.5 0 11.853.147l3 3a.5.5 0 010 .707l-3 3A.5.5 0 01.5 7z",
    fill: "currentColor"
  })));
}
export default SvgChevronRight;